import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PricingSection } from "../components/PricingSection";
import { DISCLAIMER } from "../constants";

export default function Pricing() {
  return (
    <div className="cc cc-bg min-h-screen text-slate-200 px-5 sm:px-8 py-12">
      <div className="max-w-7xl mx-auto">
        <Link to="/credit" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-10">
          <ArrowLeft size={16} /> Back
        </Link>
        <div className="text-center mb-12">
          <h1 className="cc-heading text-4xl sm:text-5xl font-700 tracking-tighter text-white">
            Plans that grow with you
          </h1>
          <p className="text-slate-400 mt-4">Monthly or yearly billing · Save 20% annually · Cancel anytime</p>
        </div>
        <PricingSection />
        <p className="text-xs text-slate-500 leading-relaxed max-w-3xl mx-auto mt-14 text-center">{DISCLAIMER}</p>
      </div>
    </div>
  );
}
